const business_entity_notices = {
  permissionSource: 'api::business-entity-notice.business-entity-notice',
  creationTitle: 'Create Business Entity Notice',
  creationEndPoint: '/business-entity-notices',
  detailTitle: 'Business Entity Notice: :title',
  detailEndPoint: '/business-entity-notices/:id?populate[0]=attachments',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Title',
              value: 'title',
              tag: 'input',
              type: 'text',
              required: true,
            },
            {
              label: 'Description',
              value: 'description',
              tag: 'richTextarea',
            },
          ],
        },
        {
          label: 'Attachments',
          value: 'attachments',
          tag: 'multi-media',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}

export default business_entity_notices
